import { Button,Col, Container, Row } from "react-bootstrap";
import { navigateTo } from "../utils/commonFunctions";

export default function UpgradeComponent({}){
  return (<>  
    <Container fluid>      
      <Row >         
        <Col className="welcome-login py-5 text-center" style={{maxWidth:"450px"}}>
          <div className="login-titulo fs-2 text-center fw-semibold lh-sm">
            Lo sentimos, ¡Agostaste tus preguntas gratis!
          </div>
          <div className="mt-3 fs-5">
            Suscríbete ahora y disfruta de todos los beneficios que El Universal tiene para ti
          </div>
          <div className="mt-4">
            <Button className="btn-upgrade p-2 fs-5" onClick={navigateTo} >
              <svg className="me-1" width="18" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_724_3545)">
                <path d="M20.5668 5.7207H6.17578V19.1286H20.5668V5.7207Z" fill="white"/>
                <path d="M12.4777 0C5.86312 0 0.5 5.36312 0.5 11.9777C0.5 18.5922 5.86312 23.9554 12.4777 23.9554C13.4608 23.9554 14.8911 23.9554 16.4553 23.9554L6.6229 14.1229V9.8324H10.3324V6.07822H14.6229L24.4554 15.9106C24.4554 14.3464 24.4554 12.9162 24.4554 11.933C24.5 5.36312 19.1368 0 12.4777 0Z" fill="#FDAE01"/>
                <path d="M14.6675 9.83231H18.377V14.1228H14.6228V17.877H10.3323V14.1228H6.57812L16.4105 23.9552C20.12 23.9552 24.4552 23.9552 24.4552 23.9552C24.4552 23.9552 24.4552 19.62 24.4552 15.9105L14.6228 6.07812V9.83231H14.6675Z" fill="#E5A324"/>
                <path d="M20.4074 14.7689V9.31641H4.63086V14.7689H20.4074Z" fill="white"/>
                <path d="M9.75 19.927H15.2026V4.15039H9.75V19.927Z" fill="white"/>
              </g>        
              </svg>
              Mejorar plan
            </Button>
          </div>
        </Col>
      </Row>
    </Container> 
  </>);
}